import { KnownErrorInfo } from 'app/models/ApiErrors';

import { formatMessage } from 'utils/messages/utils';

export const getRuleDeleteErrorToastText = (knownError: KnownErrorInfo, includedRuleCount?: number): string => {
  let messageBody = formatMessage('FAIL_BULK_DELETE_TERRITORY_GENERIC');

  if (knownError?.errorCode === 'REMOVE_RULE_HAS_OVERLAY_DEPENDENCY') {
    messageBody = formatMessage('REMOVE_RULE_HAS_OVERLAY_DEPENDENCY');
  } else if (knownError?.errorCode === 'REMOVE_RULE_HAS_ONGOING_TERRITORY_OPTIMIZATION') {
    messageBody = formatMessage('REMOVE_RULE_HAS_ONGOING_TERRITORY_OPTIMIZATION');
  } else if (includedRuleCount === 1) {
    messageBody = formatMessage('FAIL_BULK_DELETE_TERRITORY', { count: includedRuleCount });
  } else if (includedRuleCount > 1) {
    messageBody = formatMessage('FAIL_BULK_DELETE_TERRITORIES', { count: includedRuleCount });
  }
  return messageBody;
};
